import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { ChunkLoadErrorHandler } from './core/handlers/chunk-load-error.handler';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { ngxsProviders } from './core/store/ngxs.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NGXS_PLUGINS } from '@ngxs/store';
import { logoutPlugin } from './core/store/store-logout-plugin/store-logout-plugin';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { provideAnimations } from '@angular/platform-browser/animations';
import { materialProviders } from './core/material.config';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { primeNgTranslationEs } from './core/primeng.config';

// Register AG Grid Modules
ModuleRegistry.registerModules([AllCommunityModule]);

const RosfarPreset = definePreset(Aura, {
  semantic: {
    primary: palette('#e30613'),
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors([authInterceptor])),
    ngxsProviders,
    provideAnimations(),
    ...materialProviders,
    {
      provide: NGXS_PLUGINS,
      useValue: logoutPlugin,
      multi: true,
    },
    provideAnimationsAsync(),
    providePrimeNG({
        theme: {
            preset: RosfarPreset,
            options: {
                darkModeSelector: false
            }
        },
        translation: primeNgTranslationEs
    })
  ],
};
